/**
 * Date-extensions locale Spanish (Dominican Republic) [es-do]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('es-do', {
    monthNames: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
    monthShortNames: ['Ene.','Feb.','Mar.','Abr.','May.','Jun.','Jul.','Ago.','Sep.','Oct.','Nov.','Dic.'],
    dayNames: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
    dayShortNames: ['Dom.','Lun.','Mar.','Mié.','Jue.','Vie.','Sáb.']
});
